import Paragraph from '../Paragraph/Paragraph'
import classes from './StopButton.module.scss'
import { Icons } from '../..'

export interface Props {
  'aria-label'?: string
  onClick: () => void
  title?: string
  children?: string
}

const StopButton = ({
  'aria-label': ariaLabel,
  onClick,
  title,
  children
}: Props) => {
  const handleClick = () => {
    onClick() // Prevent the event from being passed
  }

  const getButtonClasses = (): string => {
    if (!children) return classes.StopButton

    return classes.StopButtonWithText
  }

  return (
    <button
      aria-label={ariaLabel}
      className={getButtonClasses()}
      onClick={handleClick}
      title={title}
      type='button'
    >
      <Icons.Stop size='16' />
      {
        children &&
          <Paragraph>
            <strong>
              {children}
            </strong>
          </Paragraph>
      }
    </button>
  )
}

export default StopButton
